export default "__VITE_PUBLIC_ASSET__429c3f2c__"